import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@planuze/ui';
import { MessageSquareText } from 'lucide-react';
import { useSupportContent } from '../../content/sections/support.js';

/* Ids estáveis dos templates de resposta rápida — o texto (label + mensagem inserida no
   composer) mora no catálogo bilíngue (`content/sections/support.ts`). */
const QUICK_TEMPLATE_IDS = ['refund', 'plan', 'logged'] as const;

export function QuickActionsMenu({ onSelect }: { readonly onSelect: (text: string) => void }) {
  const copy = useSupportContent();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={copy.quickActions.triggerAriaLabel}>
          <MessageSquareText className="size-4" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {QUICK_TEMPLATE_IDS.map((id) => {
          const template = copy.quickActions.templates[id];
          return (
            <DropdownMenuItem key={id} onClick={() => onSelect(template.text)}>
              {template.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
